export default __webpack_public_path__ + "static/media/Blank-dark.448468db.svg";